import { Button, Icon } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import calendar from "../assets/calendar.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    alignSelf: "center",
    padding: "0px 20px",
    marginBottom: "25px",
    width: "100%",
    maxWidth: "500px",
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "5px",
    border: "1px solid rgba(224, 224, 224, 1)",
    "& p": {
      fontSize: "1.5rem",
      fontWeight: "200",
      padding: "10px 0px",
    },
  },
  title: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: "4px 4px 0px 0px",
  },
  vaccine: {
    fontWeight: "400 !important",
    color: theme.palette.primary.main,
  },
  dateContainer: {
    alignSelf: "center",
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
    padding: "0px 10px",
  },
  date: {
    fontSize: "1.2rem !important",
    padding: "10px !important",
  },
}));

const VaccineCard = ({ name, brand, ageRange, date, link }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.mainContainer}>
        <p className={classes.title}>{name}</p>
        <p>{ageRange}</p>
        <p className={classes.vaccine}>{brand}</p>
        <div className={classes.dateContainer}>
          <img src={calendar} alt="_" width="40px" />
          <p className={classes.date}>{date}</p>
          <img src={calendar} alt="_" width="40px" />
        </div>
        <Button
          className={classes.infoButton}
          variant="contained"
          color="primary"
          onClick={() => {
            window.open(link, "_blank");
          }}
          startIcon={<Icon>feed</Icon>}
        >
          Información!
        </Button>
      </div>
    </div>
  );
};

export default VaccineCard;
